<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
    :title="title"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, BarElement, CategoryScale, LinearScale)

@Component({
  components: {
    Bar
  }
})
export default class BarChart extends Vue {
  @Prop({ default: 'bar-chart' }) readonly chartId!: string
  @Prop({ default: 'label' }) readonly datasetIdKey!: string
  @Prop({ default: 400 }) readonly width!: number
  @Prop({ default: 400 }) readonly height!: number
  @Prop({ default: '' }) readonly cssClasses!: string
  @Prop({ default: () => ({}) }) readonly styles!: object
  @Prop({ default: () => [] }) readonly plugins!: Array<any>
  @Prop({ default: 'Metrics' }) readonly title!: string
  @Prop({ default: () => ({}) }) readonly chartData!: object

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false
  }
}
</script>
